import * as types from "./dndUploadProgressTypes";

export const startDndUpload = ({
  uploadId,
  fileName,
  source,
  startedAt = Date.now()
}: {
  uploadId: string;
  fileName: string;
  source: types.DndUploadSource;
  startedAt?: number;
}): types.DndUploadStartAction => ({
  type: types.DND_UPLOAD_START,
  uploadId,
  fileName,
  source,
  startedAt
});

export const updateDndUploadProgress = ({
  uploadId,
  progress
}: {
  uploadId: string;
  progress: number;
}): types.DndUploadProgressAction => ({
  type: types.DND_UPLOAD_PROGRESS,
  uploadId,
  progress
});

export const completeDndUpload = ({
  uploadId,
  completedAt = Date.now()
}: {
  uploadId: string;
  completedAt?: number;
}): types.DndUploadCompleteAction => ({
  type: types.DND_UPLOAD_COMPLETE,
  uploadId,
  completedAt
});

export const failDndUpload = ({
  uploadId,
  errorMessage,
  completedAt = Date.now()
}: {
  uploadId: string;
  errorMessage?: string;
  completedAt?: number;
}): types.DndUploadFailAction => ({
  type: types.DND_UPLOAD_FAIL,
  uploadId,
  errorMessage,
  completedAt
});

export const dismissDndUpload = ({
  uploadId
}: {
  uploadId: string;
}): types.DndUploadDismissAction => ({
  type: types.DND_UPLOAD_DISMISS,
  uploadId
});

export const dismissAllCompletedDndUploads =
  (): types.DndUploadDismissAllCompletedAction => ({
    type: types.DND_UPLOAD_DISMISS_ALL_COMPLETED
  });
